import {
  isFalseMargins,
  isExcision,
  isNail,
  isPunch,
  isShave,
} from "./conditions";
import { GrossingSegment } from "./segments";

// Segments that may be shared across specimen types

export const emptySegment: GrossingSegment[] = [
  // A general segment to use whenever a Specimen is empty
  // Currently triggered by the 'empty' modifier, to be integrated holistically
  // ... with an `empty` `LabFlag` in the future
  {
    content:
      "No specimen was identified in the vial. The vial was thoroughly examined by a supervisor to confirm.",
  },
  {
    content:
      " The pathologist and medical director were notified on {empty_datetime}.",
  },
  {
    content:
      " Additional investigation performed per pathologist instructions.",
  },
  {
    content: " A filter bag was used; no tissue was identified.",
    condition: (s) => s.modifierSelections.filterBag,
  },
  {
    content: " Cell-block was performed; no tissue was detected.",
    condition: (s) => s.modifierSelections.cellBlock,
  },
  {
    content: " The provider was subsequently notified.",
  },
];

export const softenedAndDecalcifiedSegments: GrossingSegment[] = [
  {
    content: " [softened][softenedAndDecalcified][decalcified].",
    condition: ({ modifierSelections }) =>
      modifierSelections.softened || modifierSelections.decalcified,
  },
];

export const falseMarginsSegments: GrossingSegment[] = [
  {
    content:
      " The {fm_margin_a} to {fm_margin_b} section is further {fm_grossed}, and the false margin[fmS] [fmIsAre] inked {fm_color} and submitted in cassette[fmS] {fm_cassette_choice}{fm_cassette_range}.",
    condition: isFalseMargins,
  },
];

export const smallTissueSegments: GrossingSegment[] = [
  {
    content:
      " Due to the small size of the tissue it  may not survive processing.",
    condition: (s) =>
      (isShave(s) || isPunch(s) || isExcision(s) || isNail(s)) &&
      s.modifierSelections.small,
  },
];

export const incidentalForeignBodySegments: GrossingSegment[] = [
  {
    content:
      " Included with the specimen is a {fb_text} that measures {fb_w} cm x {fb_l} cm x {fb_h} cm. The foreign body is photographed and stored per protocol.",
    condition: (s) => s.modifierSelections.incidentalForeignBody,
  },
];
